export default {"src":"/_next/static/media/HOG.b40eeaf2.svg","height":18,"width":18};